import { render, staticRenderFns } from "./customer-table.vue?vue&type=template&id=cc5c0ff4&scoped=true&"
import script from "./customer-table.vue?vue&type=script&lang=js&"
export * from "./customer-table.vue?vue&type=script&lang=js&"
import style0 from "./customer-table.vue?vue&type=style&index=0&id=cc5c0ff4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5c0ff4",
  null
  
)

export default component.exports